/**
 * Creates and hydrates form state from fields
 * @param {*} fields
 * @param {*} data
 * @returns
 */
export function createFormState(fields, data) {
  const formState = {};

  // Loops through data instead
  fields.forEach((field) => {
    formState[field] = {
      // Hydrate using data if field exists
      value: data ? data[field] : "",
      touched: false,
    };
  });

  return formState;
}
